import { RemoteGetActivityByStatus } from 'data/usecases';
import { GetActivityByStatus } from 'domain/usecases';
import { makeApiUrlActivityByStatus } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetActivityByStatus = (): GetActivityByStatus =>
  new RemoteGetActivityByStatus(
    makeApiUrlActivityByStatus(),
    makeAxiosHttpClient(),
  );
